var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverageGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Proximo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_825_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M63,59H1c-0.55225,0-1-0.44727-1-1V5c0-0.55273,0.44775-1,1-1h62c0.55225,0,1,0.44727,1,1v53 C64,58.55273,63.55225,59,63,59z M2,57h60V6H2V57z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_845_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M59,55H5c-0.55225,0-1-0.44727-1-1V17c0-0.55273,0.44775-1,1-1h54c0.55225,0,1,0.44727,1,1v37 C60,54.55273,59.55225,55,59,55z M6,53h52V18H6V53z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_839_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M63,14H1c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h62c0.55225,0,1,0.44727,1,1S63.55225,14,63,14z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_840_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M51,10c-0.26025,0-0.52002-0.11035-0.70996-0.29004C50.10986,9.51953,50,9.25977,50,9 s0.10986-0.52051,0.29004-0.70996c0.36963-0.37012,1.0498-0.37012,1.41992,0C51.88965,8.47949,52,8.74023,52,9 s-0.11035,0.51953-0.29004,0.70996C51.52002,9.88965,51.27002,10,51,10z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_841_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M55,10c-0.27002,0-0.52002-0.11035-0.70996-0.2998C54.10986,9.51953,54,9.25977,54,9 s0.10986-0.52051,0.29004-0.70996c0.36963-0.37012,1.0498-0.37012,1.41992,0C55.88965,8.47949,56,8.74023,56,9 s-0.11035,0.51953-0.29004,0.70996C55.52002,9.88965,55.27002,10,55,10z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_842_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M59,10c-0.27002,0-0.52002-0.11035-0.70996-0.2998C58.10986,9.51953,58,9.25977,58,9 s0.10986-0.52051,0.29004-0.70996c0.35986-0.37012,1.0498-0.37012,1.41992,0C59.88965,8.47949,60,8.74023,60,9 s-0.11035,0.51953-0.29004,0.70996C59.52002,9.88965,59.25977,10,59,10z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_843_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M47,14c-0.55225,0-1-0.44727-1-1V5c0-0.55273,0.44775-1,1-1s1,0.44727,1,1v8C48,13.55273,47.55225,14,47,14 z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_859_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M26,39H11c-0.55225,0-1-0.44727-1-1V23c0-0.55273,0.44775-1,1-1h15c0.55225,0,1,0.44727,1,1v15 C27,38.55273,26.55225,39,26,39z M12,37h13V24H12V37z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_873_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M53,24H33c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h20c0.55225,0,1,0.44727,1,1S53.55225,24,53,24z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_774_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M53,29H33c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h20c0.55225,0,1,0.44727,1,1S53.55225,29,53,29z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_776_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M53,34H33c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h20c0.55225,0,1,0.44727,1,1S53.55225,34,53,34z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_775_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M53,39H33c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h20c0.55225,0,1,0.44727,1,1S53.55225,39,53,39z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_890_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M53,44H11c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h42c0.55225,0,1,0.44727,1,1S53.55225,44,53,44z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_891_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M53,49H11c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h42c0.55225,0,1,0.44727,1,1S53.55225,49,53,49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverageGrey);
export default __webpack_public_path__ + "static/media/coverage_grey.f317aafc5978175a4bea15670b35ef5c.svg";
export { ForwardRef as ReactComponent };